//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Hemoglobin_A1c',
  data () {
    return {
      form: {
        input1: '',
        input2: '',
        input3: '',
        input4: ''
      },
      oldFrom: {
        input1: '',
        input2: '',
        input3: '',
        input4: ''
      },
      hasScore: false,
      disabled: false,
      dataList: [
        {
          HbA1c1: 4.0,
          HbA1c2: 20
        },
        {
          HbA1c1: 4.1,
          HbA1c2: 21
        },
        {
          HbA1c1: 4.2,
          HbA1c2: 22
        },
        {
          HbA1c1: 4.3,
          HbA1c2: 23
        },
        {
          HbA1c1: 4.4,
          HbA1c2: 25
        },
        {
          HbA1c1: 4.5,
          HbA1c2: 26
        },
        {
          HbA1c1: 4.6,
          HbA1c2: 27
        },
        {
          HbA1c1: 4.7,
          HbA1c2: 28
        },
        {
          HbA1c1: 4.8,
          HbA1c2: 29
        },
        {
          HbA1c1: 4.9,
          HbA1c2: 30
        },
        {
          HbA1c1: 5.0,
          HbA1c2: 31
        },
        {
          HbA1c1: 5.1,
          HbA1c2: 32
        },
        {
          HbA1c1: 5.2,
          HbA1c2: 33
        },
        {
          HbA1c1: 5.3,
          HbA1c2: 34
        },
        {
          HbA1c1: 5.4,
          HbA1c2: 36
        },
        {
          HbA1c1: 5.5,
          HbA1c2: 37
        },
        {
          HbA1c1: 5.6,
          HbA1c2: 38
        },
        {
          HbA1c1: 5.7,
          HbA1c2: 39
        },
        {
          HbA1c1: 5.8,
          HbA1c2: 40
        },
        {
          HbA1c1: 5.9,
          HbA1c2: 41
        },
        {
          HbA1c1: 6.0,
          HbA1c2: 42
        },
        {
          HbA1c1: 6.1,
          HbA1c2: 43
        },
        {
          HbA1c1: 6.2,
          HbA1c2: 44
        },
        {
          HbA1c1: 6.3,
          HbA1c2: 45
        },
        {
          HbA1c1: 6.4,
          HbA1c2: 46
        },
        {
          HbA1c1: 6.5,
          HbA1c2: 48
        },
        {
          HbA1c1: 6.6,
          HbA1c2: 49
        },
        {
          HbA1c1: 6.7,
          HbA1c2: 50
        },
        {
          HbA1c1: 6.8,
          HbA1c2: 51
        },
        {
          HbA1c1: 6.9,
          HbA1c2: 52
        },
        {
          HbA1c1: 7.0,
          HbA1c2: 53
        },
        {
          HbA1c1: 7.1,
          HbA1c2: 54
        },
        {
          HbA1c1: 7.2,
          HbA1c2: 55
        },
        {
          HbA1c1: 7.3,
          HbA1c2: 56
        },
        {
          HbA1c1: 7.4,
          HbA1c2: 57
        },
        {
          HbA1c1: 7.5,
          HbA1c2: 58
        },
        {
          HbA1c1: 7.6,
          HbA1c2: 60
        },
        {
          HbA1c1: 7.7,
          HbA1c2: 61
        },
        {
          HbA1c1: 7.8,
          HbA1c2: 62
        },
        {
          HbA1c1: 7.9,
          HbA1c2: 63
        },
        {
          HbA1c1: 8.0,
          HbA1c2: 64
        },
        {
          HbA1c1: 8.1,
          HbA1c2: 65
        },
        {
          HbA1c1: 8.2,
          HbA1c2: 66
        },
        {
          HbA1c1: 8.3,
          HbA1c2: 67
        },
        {
          HbA1c1: 8.4,
          HbA1c2: 68
        },
        {
          HbA1c1: 8.5,
          HbA1c2: 69
        },
        {
          HbA1c1: 8.6,
          HbA1c2: 70
        },
        {
          HbA1c1: 8.7,
          HbA1c2: 72
        },
        {
          HbA1c1: 8.8,
          HbA1c2: 73
        },
        {
          HbA1c1: 8.9,
          HbA1c2: 74
        },
        {
          HbA1c1: 9.0,
          HbA1c2: 75
        },
        {
          HbA1c1: 9.1,
          HbA1c2: 76
        },
        {
          HbA1c1: 9.2,
          HbA1c2: 77
        },
        {
          HbA1c1: 9.3,
          HbA1c2: 78
        },
        {
          HbA1c1: 9.4,
          HbA1c2: 79
        },
        {
          HbA1c1: 9.5,
          HbA1c2: 80
        },
        {
          HbA1c1: 9.6,
          HbA1c2: 81
        },
        {
          HbA1c1: 9.7,
          HbA1c2: 82
        },
        {
          HbA1c1: 9.8,
          HbA1c2: 84
        },
        {
          HbA1c1: 9.9,
          HbA1c2: 85
        },
        {
          HbA1c1: 10.0,
          HbA1c2: 86
        },
        {
          HbA1c1: 10.1,
          HbA1c2: 87
        },
        {
          HbA1c1: 10.2,
          HbA1c2: 88
        },
        {
          HbA1c1: 10.3,
          HbA1c2: 89
        },
        {
          HbA1c1: 10.4,
          HbA1c2: 90
        },
        {
          HbA1c1: 10.5,
          HbA1c2: 91
        },
        {
          HbA1c1: 10.6,
          HbA1c2: 92
        },
        {
          HbA1c1: 10.7,
          HbA1c2: 93
        },
        {
          HbA1c1: 10.8,
          HbA1c2: 95
        },
        {
          HbA1c1: 10.9,
          HbA1c2: 96
        },
        {
          HbA1c1: 11.0,
          HbA1c2: 97
        },
        {
          HbA1c1: 11.1,
          HbA1c2: 98
        },
        {
          HbA1c1: 11.2,
          HbA1c2: 99
        },
        {
          HbA1c1: 11.3,
          HbA1c2: 100
        },
        {
          HbA1c1: 11.4,
          HbA1c2: 101
        },
        {
          HbA1c1: 11.5,
          HbA1c2: 102
        },
        {
          HbA1c1: 11.6,
          HbA1c2: 103
        },
        {
          HbA1c1: 11.7,
          HbA1c2: 104
        },
        {
          HbA1c1: 11.8,
          HbA1c2: 105
        },
        {
          HbA1c1: 11.9,
          HbA1c2: 106
        },
        {
          HbA1c1: 12.0,
          HbA1c2: 108
        },
        {
          HbA1c1: 12.1,
          HbA1c2: 109
        },
        {
          HbA1c1: 12.2,
          HbA1c2: 110
        },
        {
          HbA1c1: 12.3,
          HbA1c2: 111
        },
        {
          HbA1c1: 12.4,
          HbA1c2: 112
        },
        {
          HbA1c1: 12.5,
          HbA1c2: 113
        },
        {
          HbA1c1: 12.6,
          HbA1c2: 114
        },
        {
          HbA1c1: 12.7,
          HbA1c2: 115
        },
        {
          HbA1c1: 12.8,
          HbA1c2: 116
        },
        {
          HbA1c1: 12.9,
          HbA1c2: 117
        },
        {
          HbA1c1: 13.0,
          HbA1c2: 119
        }
      ],
      isLoading: false
    }
  },
  created () {
    this.hideLoad()
  },
  watch: {

  },
  methods: {
    ...mapMutations(['hideLoad']),
    handleChangeInput1 () {
      this.handleCount1()
    },
    handleCount1 () {
      for (let i = 0; i < this.dataList.length; i++) {
        const element = this.dataList[i]
        if (element.HbA1c1 == this.form.input1) {
          this.$set(this.form, 'input2', element.HbA1c2.toFixed(2))
          this.$set(this.form, 'input3', ((element.HbA1c1 * 1.59) - 2.59).toFixed(2))
          this.$set(this.form, 'input4', (this.form.input3 * 18.018).toFixed(0))
        }
      }
      this.oldFrom = JSON.parse(JSON.stringify(this.form))
      this.$forceUpdate()
    },
    handleChangeInput2 () {
      let num = this.form.input2
      this.form.input1 = this.findObj(num).HbA1c1
      this.form.input3 = ((this.form.input1 * 1.59) - 2.59).toFixed(2)
      this.form.input4 = (this.form.input3 * 18.018).toFixed(0)
    },
    findObj (num) {
      for (let i = 0; i < this.dataList.length; i++) {
        const element = this.dataList[i]
        if (element.HbA1c2 == num) {
          return element
        }
      }
      return this.findObj(num - 1)
    },
    handleChangeInput3 () {
      let num = ((Number(this.form.input3) + 2.59) / 1.59).toFixed(1)
      for (let i = 0; i < this.dataList.length; i++) {
        const element = this.dataList[i]
        if (element.HbA1c1 == num) {
          this.$set(this.form, 'input1', element.HbA1c1.toString())
          this.$set(this.form, 'input2', element.HbA1c2.toFixed(2))
          this.$set(this.form, 'input4', (this.form.input3 * 18.018).toFixed(0))
          return
        }
      }
      this.$set(this.form, 'input1', '')
      this.$set(this.form, 'input2', '')
      this.$set(this.form, 'input4', (this.form.input3 * 18.018).toFixed(0))
      console.log('handleChangeInput3', ((Number(this.form.input3) + 2.59) / 1.59).toFixed(1))
    },
    handleChangeInput4 () {
      this.$set(this.form, 'input3', (this.form.input4 / 18.018).toFixed(2))
      let num = ((Number(this.form.input3) + 2.59) / 1.59).toFixed(1)
      console.log('handleChangeInput4', ((Number(this.form.input3) + 2.59) / 1.59).toFixed(1))
      for (let i = 0; i < this.dataList.length; i++) {
        const element = this.dataList[i]
        if (element.HbA1c1 == num) {
          this.$set(this.form, 'input1', element.HbA1c1.toString())
          this.$set(this.form, 'input2', element.HbA1c2.toFixed(2))
          return
        }
      }
      this.$set(this.form, 'input1', '')
      this.$set(this.form, 'input2', '')
    },
    // 一个函数，用于比较对象的新旧状态
    compareObjects (oldObj, newObj) {
      let changes = {}

      for (let key in newObj) {
        if (newObj.hasOwnProperty(key) && newObj[key] !== oldObj[key]) {
          changes = {
            valueKey: key,
            newValue: newObj[key]
          }
        }
      }

      return changes
    }

  },
  computed: {
    /** 计算公式结果 */
    // score () {
    // let self = this
    // let form = JSON.parse(JSON.stringify(self.form))
    // let flag = true
    // for (const key in form) {
    //   if (form.hasOwnProperty(key)) {
    //     if (!form[key]) {
    //       flag = false
    //     } else {
    //       if (form[key] == '---') {
    //         flag = false
    //       } else {
    //         form[key] = Number(form[key])
    //       }
    //     }
    //   }
    // }
    // if (!flag) {
    //   self.hasScore = false
    //   return '--'
    // } else {
    //   // gender==0 ?	(fh + mh + 13) / 2 :	(fh + mh - 13) / 2
    //   let result = form.input
    //   self.hasScore = true
    //   return String(result.toFixed(5))
    // }
    // }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Hemoglobin_A1c.vue